import { Step2FormProps, WizzardStep2Form } from "../types"
import { useForm } from "react-hook-form"
import * as yup from "yup"
import { useCallback, useEffect, useMemo } from "react"
import { DefaultValue } from "../constants"
import useActivationObject from "../../../providers/ActivationObjectProvider/hooks/useActivationObject"
import { ActivationObject } from "../../../providers/ActivationObjectProvider/types"
import { VALIDATION_REQUIRED } from "../../../../constants/validation"
import { dateTimeToApiString } from "../../../../utils/dateTimeUtils"

export const useStep2Form = (activationObject?: ActivationObject): Step2FormProps => {
    const propName = (name: keyof WizzardStep2Form): string => name

    const validDate = yup.date().required(VALIDATION_REQUIRED).typeError("Neplatný formát")

    const validationSchema = useMemo(
        () =>
            yup.object().shape({
                [propName("handoverDate")]: yup.date().nullable(),
                [propName("handoverHour")]: yup.number().nullable(),
                [propName("destroyKey")]: yup.boolean().nullable(),
                [propName("backHandoverHour")]: yup.number().nullable(),
            }),
        []
    )

    const form = useForm<WizzardStep2Form>({
        criteriaMode: "all",
        reValidateMode: "onChange",
        // resolver: yupResolver(validationSchema),
        defaultValues: DefaultValue,
    })

    const reset = form.reset
    useEffect(() => {
        if (activationObject) {
            reset({
                personType: activationObject?.personType ?? DefaultValue.personType,
                objectTypeAnother: activationObject.objectTypeAnother ?? DefaultValue.objectTypeAnother,
                arrivalVehicle: activationObject.arrivalVehicle ?? DefaultValue.arrivalVehicle,
                handoverDate:
                    activationObject && activationObject.handoverKeysDateTime
                        ? new Date(activationObject.handoverKeysDateTime)
                        : DefaultValue.handoverDate,
                handoverHour: activationObject.handoverKeysDateTime
                    ? new Date(activationObject.handoverKeysDateTime).getHours()
                    : DefaultValue.handoverHour,
                backHandoverDate:
                    activationObject && activationObject.backHandoverKeysDateTime
                        ? new Date(activationObject.backHandoverKeysDateTime)
                        : DefaultValue.handoverDate,
                destroyKey: activationObject.destroyKey ?? activationObject.destroyKey,
                backHandoverHour: activationObject.backHandoverKeysDateTime
                    ? new Date(activationObject.backHandoverKeysDateTime).getHours()
                    : DefaultValue.handoverHour,
                selectService: activationObject.selectService ?? DefaultValue.selectService,
            })
        }
    }, [activationObject, reset])

    const { update } = useActivationObject()

    const onSubmit = useCallback(
        (data: WizzardStep2Form) => {
            if (activationObject) {
                const handoverKeysDateTime = data.handoverDate
                const backHandoverKeysDateTime = data.backHandoverDate

                if (handoverKeysDateTime) {
                    handoverKeysDateTime.setHours(data.handoverHour || 0)
                    handoverKeysDateTime.setMinutes(0)
                }

                if (backHandoverKeysDateTime) {
                    backHandoverKeysDateTime.setHours(data.backHandoverHour || 0)
                    backHandoverKeysDateTime.setMinutes(0)
                }

                const newObject: ActivationObject = {
                    ...activationObject,
                    ...data,
                    objectSize: data.objectSize === "" ? null : data.objectSize,
                    handoverKeysDateTime: handoverKeysDateTime ? dateTimeToApiString(handoverKeysDateTime) : null,
                    backHandoverKeysDateTime: backHandoverKeysDateTime ? dateTimeToApiString(backHandoverKeysDateTime) : null,
                }

                update({ ...newObject })
            }
        },
        [activationObject, update]
    )

    return {
        form,
        onSubmit,
    }
}
